<template>
<div class="page_qrcode">
    <!-- 切换 -->
    <div class="tab" style="z-index:999;" @click="changeTab">换一换</div>
    <!-- 普通二维码 -->
    <div class="default" v-if="!type">
        <img :src="imageUrl+tradesmanQRCode.path" alt="" class="qrcode" v-if="tradesmanQRCode.path">
        <div class="" v-if="!tradesmanQRCode.path">无</div>
        <!-- <img :src="publicPath+'statics/images/default_goods.png'" alt="" class="qrcode"> -->
    </div>
    <!-- 合成二维码 -->
    <div class="default" v-if="type">
        <img :src="imageUrl+tradesmanQRCode.path_new" alt="" class="hechengqrcode" v-if="tradesmanQRCode.path_new">
        <div class="" v-if="!tradesmanQRCode.path_new">无</div>
        <!-- <img :src="publicPath+'statics/images/temp/hecheng.png'" alt="" class="hechengqrcode"> -->
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    // name: "map-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: null,
            tradesmanQRCode: {},
            type: 0 // 0普通二维码 1合成二维码
        };
    },

    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {
                data: {
                    naviTitle: "商家二维码"
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, data => {});
            //加载用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
        }
    },
    methods: {
        // 获取列表
        getData() {
            var param = {
                token: this.token
            }
            this.$api.tradesman.qrcode(param).then(res => {
                if (res.code == 200) {
                    this.tradesmanQRCode = res.result
                    if (res.result.path_new) {
                        this.type = 1
                    }
                } else {
                    this.$toast(res.message)
                }
            })
        },
        changeTab() {
            console.log('type', this.type)
            if (this.type) {
                this.type = 0
            } else if (!this.type) {
                this.type = 1
            }
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
